import React from 'react';

import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { LiabilityEntityIndex } from '@funnels/types';
import { bsbFormatter, bsbParser, validateFixedLength } from '@funnels/utils';

import TextInputField from '../../Fields/TextInputField';
import { FunnelViewProps } from '../types';

interface LiabilityAccountBSBCustomerViewProps extends FunnelViewProps, LiabilityEntityIndex {
  label?: string;
}

export const LiabilityAccountBSBCustomerView = (props: LiabilityAccountBSBCustomerViewProps) => {
  const { liabilityIndex, label = 'BSB' } = props;

  return (
    <TextInputField
      name={FIELD_PATHS.LIABILITY_BSB(liabilityIndex)}
      label={label}
      className={PII_FIELD_MASKING_CLASS}
      format={bsbFormatter}
      parse={bsbParser}
      validate={validateFixedLength('Please provide a valid BSB number', 6, true)}
      isOptional
    />
  );
};

export const LiabilityAccountBSBTeamView = ({ liabilityIndex }: { liabilityIndex: number }) => (
  <TextInputField
    name={FIELD_PATHS.LIABILITY_BSB(liabilityIndex)}
    label="BSB"
    format={bsbFormatter}
    parse={bsbParser}
    isOptional
    className={PII_FIELD_MASKING_CLASS}
    validate={validateFixedLength('Please provide a valid BSB number', 6, true)}
  />
);
